<template>
    <div
        :class="[
            'progress-iconography',
            props.content.showDivider.value && 'progress-iconography--show-divider',
        ]"
    >
        <div
            v-for="index in totalQuestions"
            :key="index"
            :class="[
                'progress-iconography__item',
                isChecked(index) && 'progress-iconography__item--checked',
            ]"
        >
            <div class="progress-iconography__item-icon" />
        </div>
    </div>
</template>

<script setup>
import { useStore } from 'vuex';
import {computed} from 'vue';
import { componentProps } from '../../../../../mixins/component/component';

const store = useStore();

const props = defineProps({
    ...componentProps,
    totalQuestionsOverwrite: {
        type: Number,
        default: null,
    },
    continuousFlowLength: {
        type: Number,
        default: null,
    },
});

const totalQuestions = computed(() => {
    if (props.totalQuestionsOverwrite) return props.totalQuestionsOverwrite;
    if (props.continuousFlowLength) return props.continuousFlowLength;
    return store.state.quiz.totalFlowLength;
});

const isChecked = index => {
    const isContinuousFlow = store.state.quiz.continuousFlow;

    if (isContinuousFlow) {
        const formStep = store.state.form.attributes.step;
        return index < store.state.quiz.questionCount + formStep - 1;
    }

    return index < store.state.quiz.questionCount;
};

const icon = `url(${props.content.icon.value})`;
</script>

<style lang="scss" scoped>
@use 'zoe-molecule-progress-iconography';

.progress-iconography {
    --icon: v-bind(icon);
    --icon-color: v-bind('props.content.style.iconColor.value');
    --icon-color-active: v-bind('props.content.style.iconColorActive.value');
    --divider-color: v-bind('props.content.style.dividerColor.value');
}
</style>
